import React from "react"
import Select from "react-select"

import SelectTags from "../../common/tags/SelectTags"

import { topicDimensionStatuses } from "../../../config/application-definitions"

const allStatuses = topicDimensionStatuses.map(status => ({
    id: status,
    name: status
}))

const KeyIssueFilterForm = ({ model, onEventChange, onValueChange }) => (
    <form name="filterform">
        <div className="filter-block">
            <label htmlFor="insight-area-filter-name">Name</label>
            <input
                id="insight-area-filter-name"
                type="text"
                className="form-control"
                name="name"
                value={model.name}
                onChange={onEventChange}
            />
        </div>
        <div className="filter-block">
            <label htmlFor="insight-area-filter-statuses">Statuses</label>
            <SelectTags
                name="statuses"
                SelectComponent={Select}
                value={model.statuses}
                options={allStatuses}
                onChange={onValueChange("statuses")}
            />
        </div>
        <div className="form-check">
            <label className="form-check-label">
                <input
                    className="form-check-input"
                    name="empty"
                    type="checkbox"
                    checked={model.empty}
                    onChange={onEventChange}
                />&nbsp; Only key issues without mappings
            </label>
        </div>
    </form>
)

export default KeyIssueFilterForm
